import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import '@/script/flexible'

import '@/styles/index.less'

import headTitle from './components/headTitle'
Vue.component('headTitle', headTitle)

import foot from './components/foot'
Vue.component('foot', foot)

Vue.config.productionTip = false

new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount('#app')
